




import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import SpaIndicator from '../../atoms/Indicator.vue'

@Component({
  components: {
    SpaIndicator,
  },
})
export default class DeliveryIndicator extends Vue {
  @Prop()
  currentIndex: number

  get sequences() {
    return {
      1: '準備中',
      2: '発送完了',
      /*
       * phase1では「配送完了」のステータスが判断できないので、
       * 一旦「配送完了」ステータスは除外する.
       */
      // 3: '配送完了',
    }
  }
}
